import * as React from 'react';

export const MilitaryMortgageIcon = () => (
  <svg width="56" height="56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip-military)">
      <path opacity=".6" d="M46 51H2V19.345L24 0l22 19.345V51z" fill="#fff" />
      <circle cx="39.969" cy="41.969" r="12" fill="#FFC42C" />
      <path
        d="M51.969 41.969c0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12 0-6.628 5.372-12 12-12 6.627 0 12 5.372 12 12zm-23.312 0c0 6.247 5.065 11.311 11.312 11.311 6.247 0 11.311-5.064 11.311-11.311S46.216 30.657 39.97 30.657 28.657 35.722 28.657 41.97z"
        fill="url(#military_paint0_linear)"
      />
      <path
        d="M46.984 34.953a9.921 9.921 0 11-14.03 14.031l.7-.701a8.93 8.93 0 0012.629-12.628l.701-.702z"
        fill="url(#military_paint1_linear)"
      />
      <path
        d="M32.953 48.984a9.921 9.921 0 1114.031-14.03l-.701.7a8.93 8.93 0 00-12.628 12.629l-.702.701z"
        fill="url(#military_paint2_linear)"
      />
      <path d="M25.969 3.969h28v19.48l-14 5.52-14-5.52V3.97z" fill="#3AC500" />
      <path d="M31.969 3.969h16v21.843l-8 3.157-8-3.157V3.97z" fill="#FFCE2C" />
      <path d="M36.969 3.969h6v23.797l-3 1.203-3-1.203V3.969z" fill="#3AC500" />
      <path
        d="M39.969 33.656l1.866 5.744h6.04l-4.887 3.55 1.867 5.744-4.886-3.55-4.886 3.55 1.866-5.744-4.886-3.55h6.04l1.866-5.744z"
        fill="#fff"
      />
      <path fill="url(#military_paint3_linear)" d="M25.969 3.906H54v10.313H25.969z" />
    </g>
    <defs>
      <linearGradient
        id="military_paint0_linear"
        x1="39.969"
        y1="42.469"
        x2="31.469"
        y2="33.969"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFCE2C" stopOpacity="0" />
        <stop offset="1" stopColor="#FFEAA5" />
      </linearGradient>
      <linearGradient
        id="military_paint1_linear"
        x1="39.969"
        y1="41.969"
        x2="46.984"
        y2="48.984"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC42C" />
        <stop offset="1" stopColor="#FFE693" />
      </linearGradient>
      <linearGradient
        id="military_paint2_linear"
        x1="39.969"
        y1="41.969"
        x2="32.953"
        y2="34.953"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC42C" stopOpacity="0" />
        <stop offset="1" stopColor="#E7AC16" />
      </linearGradient>
      <linearGradient
        id="military_paint3_linear"
        x1="39.984"
        y1="3.906"
        x2="39.984"
        y2="14.219"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity=".2" />
        <stop offset=".224" stopColor="#fff" stopOpacity=".62" />
        <stop offset="1" stopColor="#fff" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clip-military">
        <path fill="#fff" d="M0 0h56v56H0z" />
      </clipPath>
    </defs>
  </svg>
);

MilitaryMortgageIcon.displayName = 'MaternalCapitalIcon';
